import { j as c } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const l = s((e, o) => /* @__PURE__ */ c.jsx(
  t,
  {
    ref: o,
    ...e,
    image: (r) => /* @__PURE__ */ c.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...r,
        children: [
          /* @__PURE__ */ c.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M27.5 32.67h-7.03c-1.46 0-2.64-1.19-2.64-2.64v-.67c0-1.83 1.49-3.32 3.32-3.32h5.68c1.83 0 3.32 1.49 3.32 3.32v.67c0 1.45-1.19 2.64-2.65 2.64m-6.35-5.14c-1 0-1.82.82-1.82 1.82v.67c0 .63.51 1.14 1.14 1.14h7.03c.63 0 1.14-.51 1.14-1.14v-.67c0-1-.81-1.82-1.82-1.82zM35.31 23.87c-2.67 0-4.69-2-4.69-4.64 0-1.92 1.18-3.46 2.13-4.69 1.79-2.32 1.81-5.75 1.81-5.79 0-.41.33-.74.74-.75h.01c.4 0 .74.32.75.73 0 .04.14 3.72 1.71 5.81.15.2.31.4.46.59.83 1.05 1.77 2.24 1.77 3.94 0 2.87-1.89 4.8-4.69 4.8m-.01-10.96c-.3.85-.73 1.71-1.32 2.48-.94 1.23-1.87 2.43-1.87 3.84 0 1.82 1.34 3.14 3.19 3.14 1.97 0 3.19-1.26 3.19-3.3 0-1.18-.67-2.03-1.45-3-.17-.21-.33-.42-.49-.63-.55-.75-.96-1.65-1.25-2.53"
            }
          ),
          /* @__PURE__ */ c.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M24.03 40C15.19 40 8 32.82 8 24S15.19 8 24.03 8c2.9 0 5.74.78 8.21 2.25.36.21.47.67.26 1.03s-.67.47-1.03.26a14.5 14.5 0 0 0-7.44-2.04C16.02 9.5 9.5 16 9.5 24s6.52 14.5 14.53 14.5c7.57 0 13.79-5.66 14.47-13.17.04-.41.41-.71.81-.68.41.04.72.4.68.82C39.24 33.75 32.38 40 24.03 40"
            }
          )
        ]
      }
    )
  }
));
l.displayName = "AgencyOverwhelmedIcon";
export {
  l as AgencyOverwhelmedIcon,
  l as default
};
//# sourceMappingURL=index.js.map
